import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { ReactNode } from 'react';
import { OpenAPI } from '../../openapi';

interface Props {
  children: ReactNode;
}

export const Protect: React.FC<Props> = ({ children }) => {
  const { user } = useAuth();
  if (!user?.accessToken) return <Navigate to="/signIn" />;
  return <>{children}</>;
};
